import { EllipsisMenu, IOption, Bin, EditIcon, ViewIcon } from '@weareopenr/component-library';

interface IActionsMenu {
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

const ActionsMenu = ({ onView, onEdit, onDelete }: IActionsMenu) => {
  const ellipsisMenuOptions: IOption[] = [];

  if (onView) {
    ellipsisMenuOptions.push({
      id: 'view',
      name: 'View',
      icon: ViewIcon,
      onOptionClick: onView,
    });
  }

  if (onEdit) {
    ellipsisMenuOptions.push({
      id: 'edit',
      name: 'Edit',
      icon: EditIcon,
      onOptionClick: onEdit,
    });
  }

  if (onDelete) {
    if (ellipsisMenuOptions.length >= 2) {
      ellipsisMenuOptions.push({
        id: 'delete-divider',
        isDivider: true,
      });
    }
    ellipsisMenuOptions.push({
      id: 'delete',
      name: 'Delete',
      icon: Bin,
      onOptionClick: onDelete,
      hoverColour: 'tomato',
    });
  }

  return (
    <div
      role="none"
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <EllipsisMenu options={ellipsisMenuOptions} variant="ghost" hoverStyle="high-contrast" />
    </div>
  );
};

export default ActionsMenu;
